import RenderMailingZipAndLocations from './RenderMailingZipAndLocations'

export default RenderMailingZipAndLocations
